import withQueryParams from "../../utils/withQueryParams";
import getUserCacheKey from "../../utils/getUserCacheKey";
import productPageBaseUri from "../../utils/productPageBaseUri";

class ComplementaryProductsServiceClient {
  constructor(integrationService) {
    this._integrationService = integrationService;
  }

  fetchComplementaryProducts = async (productCode) => {
    const complementaryProductsUri = withQueryParams(`${productPageBaseUri}api/products/${productCode}/complementaryProducts`, {cacheKey: getUserCacheKey()});

    return this._integrationService.read({
      url: complementaryProductsUri,
      method: "GET",
      credentials: "include"
    });
  }
}

export default ComplementaryProductsServiceClient;
